"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var download_1 = require("./download/download");
var transform_1 = require("./transform/transform");
var player_1 = require("./player/player");
var recorder_1 = require("./recorder/recorder");
var Index = /** @class */ (function (_super) {
    __extends(Index, _super);
    /**
     * @param {Object} options 包含以下三个参数：
     * sampleBits，采样位数，一般8,16，默认16
     * sampleRate，采样率，一般 11025、16000、22050、24000、44100、48000，默认为浏览器自带的采样率
     * numChannels，声道，1或2
     */
    function Index(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, options) || this;
        _this.isrecording = false; // 是否正在录音
        _this.ispause = false; // 是否是暂停
        _this.isplaying = false; // 是否正在播放
        _this.plugins = [];
        _this.plugins = Index.Plugins.map(function (pluginUse) { return pluginUse(_this); });
        return _this;
    }
    Index.use = function (pluginUses) {
        if (!Array.isArray(pluginUses)) {
            pluginUses = [pluginUses];
        }
        pluginUses.forEach(function (item) { return Index.Plugins.push(item); });
    };
    /**
     * 重新修改配置
     *
     * @param {recorderConfig} [options={}]
     * @memberof Recorder
     */
    Index.prototype.setOption = function (options) {
        if (options === void 0) { options = {}; }
        this.setNewOption(options);
    };
    /**
     * Start the recording
     */
    Index.prototype.start = function () {
        if (this.isrecording) {
            // 正在录音，则不允许
            return Promise.reject();
        }
        this.isrecording = true;
        return this.startRecord();
    };
    /**
     * Pause the recording
     */
    Index.prototype.pause = function () {
        if (this.isrecording && !this.ispause) {
            this.ispause = true;
            // 当前不暂停的时候才可以暂停
            this.pauseRecord();
        }
    };
    /**
     * 继续录音
     */
    Index.prototype.resume = function () {
        if (this.isrecording && this.ispause) {
            this.ispause = false;
            this.resumeRecord();
        }
    };
    /**
     * 停止录音
     *
     * @memberof Recorder
     */
    Index.prototype.stop = function () {
        if (this.isrecording) {
            this.isrecording = false;
            this.ispause = false;
            this.stopRecord();
        }
    };
    /**
     * 播放录音
     */
    Index.prototype.play = function () {
        this.stop();
        // 关闭前一次音频播放
        this.isplaying = true;
        this.onplay && this.onplay();
        player_1.default.addPlayEnd(this.onplayend); // 注册播放完成后的回调事件
        var dataV = this.getWAV();
        if (dataV.byteLength > 44) {
            player_1.default.play(dataV.buffer); // 播放
        }
    };
    /**
     * 获取已经播放了多长时间
     */
    Index.prototype.getPlayTime = function () {
        return player_1.default.getPlayTime();
    };
    /**
     * 暂停播放录音
     *
     * @memberof Recorder
     */
    Index.prototype.pausePlay = function () {
        if (this.isrecording || !this.isplaying) {
            // 正在录音或没有播放，暂停无效
            return;
        }
        this.isplaying = false;
        this.onpauseplay && this.onpauseplay();
        player_1.default.pausePlay();
    };
    /**
     * 恢复播放录音
     *
     * @memberof Recorder
     */
    Index.prototype.resumePlay = function () {
        if (this.isrecording || this.isplaying) {
            // 正在录音或已经播放或没开始播放，恢复无效
            return;
        }
        this.isplaying = true;
        this.onresumeplay && this.onresumeplay();
        player_1.default.resumePlay();
    };
    /**
     * 停止播放
     *
     * @memberof Recorder
     */
    Index.prototype.stopPlay = function () {
        if (this.isrecording) {
            // 正在录音，停止录音播放无效
            return;
        }
        this.isplaying = false;
        this.onstopplay && this.onstopplay();
        player_1.default.stopPlay();
    };
    Index.prototype.destroy = function () {
        player_1.default.destroyPlay();
        this.plugins.forEach(function (item) { return (item === null || item === void 0 ? void 0 : item.destory) && (item === null || item === void 0 ? void 0 : item.destory()); });
        return this.destroyRecord();
    };
    /**
     * 获取当前已经录音的PCM音频数据
     *
     * @returns[DataView]
     * @memberof Recorder
     */
    // getWholeData() {
    //     return this.tempPCM;
    // }
    /**
     * 获取余下的新数据，不包括 getNextData 前一次获取的数据
     *
     * @returns [DataView]
     * @memberof Recorder
     */
    // getNextData() {
    //     let length = this.tempPCM.length,
    //         data = this.tempPCM.slice(this.offset);
    //     this.offset = length;
    //     return data;
    // }
    /**
     * 获取当前录音的波形数据，
     * 调取频率由外部控制。
     *
     * @memberof Recorder
     */
    Index.prototype.getRecordAnalyseData = function () {
        return this.getAnalyseData();
    };
    /**
     * 获取当前录音的波形数据，
     * 调取频率由外部控制。
     *
     * @memberof Recorder
     */
    Index.prototype.getRecordByteFrequencyData = function () {
        return this.getByteFrequencyData();
    };
    /**
     * 获取录音播放时的波形数据，
     *
     * @memberof Recorder
     */
    Index.prototype.getPlayAnalyseData = function () {
        // 现在录音和播放不允许同时进行，所有复用的录音的analyser节点。
        return player_1.default.getAnalyseData();
    };
    /**
     * 获取录音播放时的波形数据，
     *
     * @memberof Recorder
     */
    Index.prototype.getPlayAnalyseByteFrequencyData = function () {
        // 现在录音和播放不允许同时进行，所有复用的录音的analyser节点。
        return player_1.default.getAnalyseByteFrequencyData();
    };
    Index.prototype.getPCM = function () {
        // 先停止
        this.stop();
        // 获取pcm数据
        var data = this.getData();
        // 根据输入输出比例 压缩或扩展
        data = transform_1.compress(data, this.inputSampleRate, this.outputSampleRate);
        // 按采样位数重新编码
        return transform_1.encodePCM(data, this.oututSampleBits, this.littleEdian);
    };
    /**
     * 获取PCM格式的blob数据
     *
     * @returns { blob }  PCM格式的blob数据
     * @memberof Recorder
     */
    Index.prototype.getPCMBlob = function () {
        return new Blob([this.getPCM()]);
    };
    /**
     * 下载录音pcm数据
     *
     * @param {string} [name='recorder']    重命名的名字
     * @memberof Recorder
     */
    Index.prototype.downloadPCM = function (name) {
        if (name === void 0) { name = "recorder"; }
        var pcmBlob = this.getPCMBlob();
        download_1.downloadPCM(pcmBlob, name);
    };
    /**
     * 获取WAV编码的二进制数据(dataview)
     *
     * @returns {dataview}  WAV编码的二进制数据
     * @memberof Recorder
     */
    Index.prototype.getWAV = function () {
        var pcmTemp = this.getPCM();
        // PCM增加44字节的头就是WAV格式了
        return transform_1.encodeWAV(pcmTemp, this.inputSampleRate, this.outputSampleRate, this.config.numChannels, this.oututSampleBits, this.littleEdian);
    };
    /**
     * 获取WAV音频的blob数据
     *
     * @returns { blob }    wav格式blob数据
     * @memberof Recorder
     */
    Index.prototype.getWAVBlob = function () {
        return new Blob([this.getWAV()], { type: "audio/wav" });
    };
    /**
     * 下载录音的wav数据
     *
     * @param {string} [name='recorder']    重命名的名字
     * @memberof Recorder
     */
    Index.prototype.downloadWAV = function (name) {
        if (name === void 0) { name = "recorder"; }
        var wavBlob = this.getWAVBlob();
        download_1.downloadWAV(wavBlob, name);
    };
    /**
     * 通用的下载接口
     */
    Index.prototype.download = function (blob, name, type) {
        download_1.download(blob, name, type);
    };
    /**
     * 获取左和右声道的数据
     *
     * @returns [DataView]
     */
    Index.prototype.getChannelData = function () {
        var all = this.getPCM();
        var length = all.byteLength;
        var littleEdian = this.littleEdian;
        var res = { left: null, right: null };
        if (this.config.numChannels === 2) {
            // 双通道,劈开
            var lD = new DataView(new ArrayBuffer(length / 2));
            var rD = new DataView(new ArrayBuffer(length / 2));
            // 双声道，需要拆分下数据
            if (this.config.sampleBits === 16) {
                for (var i = 0; i < length / 2; i += 2) {
                    lD.setInt16(i, all.getInt16(i * 2, littleEdian), littleEdian);
                    rD.setInt16(i, all.getInt16(i * 2 + 2, littleEdian), littleEdian);
                }
            }
            else {
                for (var i = 0; i < length / 2; i += 2) {
                    lD.setInt8(i, all.getInt8(i * 2));
                    rD.setInt8(i, all.getInt8(i * 2 + 1));
                }
            }
            res.left = lD;
            res.right = rD;
        }
        else {
            // 单通道
            res.left = all;
        }
        return res;
    };
    Index.Plugins = [];
    return Index;
}(recorder_1.default));
exports.default = Index;
//# sourceMappingURL=Core.js.map